import { render, staticRenderFns } from "./adminiface.vue?vue&type=template&id=dc733e7e&scoped=true&"
import script from "./adminiface.vue?vue&type=script&lang=js&"
export * from "./adminiface.vue?vue&type=script&lang=js&"
import style0 from "./adminiface.vue?vue&type=style&index=0&id=dc733e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc733e7e",
  null
  
)

export default component.exports